export const wheels = [
	'jaconv-0.4.0-py3-none-any.whl',
	'marisa_trie-1.3.2.dev0-cp313-cp313-pyodide_2025_0_wasm32.whl',
	'aksharamukha-2.3-py3-none-any.whl'
];

export const aksharamukhaCDNIndexURL = `https://cdn.jsdelivr.net/npm/aksharamukha@2.3.0-29/dist`;
export const wheelBaseURL = 'https://github.com/paramsiddharth/aksharamukha.js/releases/download/v2.3.0-0';